import { useState } from 'react';
import Decimal from 'decimal.js';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import OpenCashRegister from './OpenCashRegister';
import CashTransferModal from './CashTransferModal';
import CloseCashRegisterModal from './CloseCashRegisterModal';
import SessionHistoryModal from './SessionHistoryModal';
import PdfButton from '../../../components/pdf/PdfButton';
import FormatDateTime from '../../../components/dateTime/FormatDateTime';
import {
  useLazyGetCashRegisterReportPdfQuery,
  useLazyGetCashRegisterExportExcelQuery,
} from '../../../redux/api/marktApi';
import { downloadBlob } from '../../../utils/download';
import { useApiErrorToast } from '../../../hooks/useApiError';

const CashRegister = ({ cashRegister }) => {
  const session = cashRegister.active_session;
  const [triggerRegisterPdf] = useLazyGetCashRegisterReportPdfQuery();
  const [fetchExcel] = useLazyGetCashRegisterExportExcelQuery();
  const [exporting, setExporting] = useState(false);
  const apiErrorToast = useApiErrorToast();

  const handleExcelExport = async () => {
    setExporting(true);
    try {
      const blob = await fetchExcel(cashRegister.id).unwrap();
      downloadBlob(blob, `kassenbuch-${cashRegister.name}.xlsx`);
    } catch (err) {
      apiErrorToast(err, 'Excel-Export konnte nicht erstellt werden');
    } finally {
      setExporting(false);
    }
  };

  return (
    <div className='col'>
      <div className='card h-100 shadow-sm'>
        <div className='card-header bg-dark text-white'>
          <h5 className='card-title mb-0'>{cashRegister.name}</h5>
        </div>
        <div className='card-body'>
          <p>
            <i
              className={`fas fa-${cashRegister.open ? 'lock-open' : 'lock'}`}
            />{' '}
            Kasse{' '}
            {cashRegister.open && session
              ? `geöffnet (von ${session.opened_by}) `
              : 'geschlossen'}
            {cashRegister.open && session && (
              <FormatDateTime dateTime={session.opened_at} />
            )}
          </p>
          <p className='mb-3'>
            <strong>Kassenstand:</strong>{' '}
            {`${new Decimal(cashRegister.balance).toFixed(2)} €`}
          </p>
          <hr />
          {cashRegister.open && session ? (
            <div className='d-flex flex-wrap gap-2'>
              <CashTransferModal session={session} direction='IN' />
              <CashTransferModal session={session} direction='OUT' />
              <CloseCashRegisterModal session={session} />
              <Link
                to={`/markt/cash-register/session/${session.id}`}
                className='btn btn-outline-secondary btn-sm'
              >
                <i className='fas fa-receipt me-1' />
                Details
              </Link>
            </div>
          ) : (
            <OpenCashRegister cashRegister={cashRegister} />
          )}

          {/* Reporting — available regardless of register state. */}
          <div className='d-flex flex-wrap gap-2 mt-2'>
            <PdfButton
              onFetch={() => triggerRegisterPdf(cashRegister.id).unwrap()}
              filename={`kassenbericht-${cashRegister.name}.pdf`}
              label='Gesamtbericht (PDF)'
              variant='outline-dark'
            />
            <Button
              variant='outline-success'
              size='sm'
              onClick={handleExcelExport}
              disabled={exporting}
            >
              <i className='fas fa-file-excel me-1' />
              Buchungen (Excel)
            </Button>
            <SessionHistoryModal cashRegister={cashRegister} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CashRegister;
